/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AelNavigationParams } from '@gh/builder-shared';
import { AelEvents, getAelEventsArray } from '@gh/builder-shared-data';
import { AbstractScheduleDetailsComponent } from '../abstract-schedule-details.component';
import { ScheduleDetailsCommandService } from '../schedule-details-command.service';
import { ScheduleDetailsFormState } from '../schedule-details-form.service';

@Component({
  selector: 'gh-sales-schedule-details',
  template: require('./sales-schedule-details.component.html'),
  providers: [ScheduleDetailsFormState, ScheduleDetailsCommandService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalesScheduleDetailsComponent extends AbstractScheduleDetailsComponent {
  baseRoutePath = 'schedules/sales';
  titlePrefix = 'lbl_sales_sch_for_sf';

  constructor(public form: ScheduleDetailsFormState,
              commands: ScheduleDetailsCommandService) {
    super(commands);
  }

  buildAelNavigationParams(): AelNavigationParams {
    return {
      label: 'lbl_sales_sch',
      entityType: 'SALES_FOLDER',
      entityId: this.form.salesFolderId,
      eventTypeIds: getAelEventsArray(AelEvents.SalesFolders.SalesSchedule),
    };
  }
}
